import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import completeIcon from "../../assets/svgs/tick-mark.svg";
import { bindActionCreators } from "redux";
import {
  setInternetStatus,
  setPendingToStartSurvey,
  startIncompleteSurvey,
} from "../../application_actions";
import classNames from "classnames";
import WarningIcon from "./WarningIcon.jsx";

const NetToast = (props) => {
  const {
    currentPageNumber,
    setInternetStatus,
    setPendingToStartSurvey,
    offlineStatusText,
    onlineStatusText,
    iotDataError,
    siteSurveyCanBeConducted,
    checkInternetConnection,
  } = props;
  const { pendingToStartSurvey, ken, countryCode } = props;
  const [isOnline, setIsOnline] = useState();
  const [showWarning, setShowWarning] = useState(false);
  const offlineDelay = 3000,
    onlineDelay = 30000;
  useEffect(() => {
    let timeouId;
    const checkConnectivity = async () => {
      try {
        const res = await fetch(`https://${window.location.host}/health-check`);
        if (isOnline !== undefined) {
          if (isOnline === false) {
            setInternetStatus(true);
          }
          setIsOnline(true);
        }
      } catch (e) {
        if (isOnline || isOnline === undefined) setInternetStatus(false);
        setIsOnline(false);
      } finally {
        clearTimeout(timeouId);
        timeouId = setTimeout(
          checkConnectivity,
          isOnline || isOnline === undefined ? onlineDelay : offlineDelay
        );
      }
    };
    checkConnectivity();
    if (isOnline !== undefined) setShowWarning(true);
    if (isOnline === true) {
      const timeout = setTimeout(() => setShowWarning(false), 7000);
      return () => clearTimeout(timeout);
    }
    return () => clearTimeout(timeouId);
  }, [isOnline]);

  useEffect(() => {
    if (pendingToStartSurvey && isOnline) {
      startIncompleteSurvey(ken, countryCode).then(() => {
        setPendingToStartSurvey(false);
      });
    }
  }, [isOnline]);

  return (
    <div className="netToast">
      {isOnline && (
        <div
          className={classNames("online", {
            "show-temp": isOnline === true && showWarning,
          })}
        >
          <div className="txt">
            <img src={completeIcon} alt="complete icon"></img>
            <p className="m-0">{onlineStatusText}</p>
          </div>
        </div>
      )}
      {!isOnline && showWarning && (
        <div className="overlay-dark">
          <div
            className={classNames("offline", {
              show: !isOnline && showWarning,
            })}
          >
            <div className="flex-row">
              <div className="warning-icon">
                <WarningIcon />
              </div>
              <div>
                <div className="title">
                  <p className="text">{offlineStatusText}</p>
                </div>
                <div>
                  <p className="t-body text">
                    {currentPageNumber < 1 || iotDataError
                      ? checkInternetConnection
                      : siteSurveyCanBeConducted}
                  </p>
                </div>
              </div>
            </div>
            <div className="footer">
              {currentPageNumber !== 0 && (
                <button
                  className="confirm"
                  onClick={() => {
                    setShowWarning(false);
                  }}
                >
                  OK
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

function mapStateToProps({ progress, app, i18n }) {
  const currentPageNumber = progress.currentIndex;
  const countryCode = app.iotData
    ? app.iotData.equipment.EquipmentCountryCode
    : null;
  return {
    currentPageNumber,
    ken: app.KEN,
    pendingToStartSurvey: app.pendingToStartSurvey,
    countryCode,
    offlineStatusText: i18n.strings.Common?.internetLost,
    onlineStatusText: i18n.strings.Common?.internetRestored,
    siteSurveyCanBeConducted: i18n.strings.Common?.siteSurveyCanBeConducted,
    checkInternetConnection: i18n.strings.ValidateEquipment?.checkInternetConnection,
    iotDataError: app.iotDataError,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { setInternetStatus, setPendingToStartSurvey },
    dispatch
  );
}

const NetworkToast = connect(mapStateToProps, mapDispatchToProps)(NetToast);
export default NetworkToast;
